/**
 * No zoom on focus on iPhone (owner feedback 2026-10-08, video 2026-10-09). iPhone Safari zoomed
 * in when a field was tapped, even with every field at 16px. `maximum-scale=1` stops that zoom,
 * and Safari on iPhone and iPad still lets people pinch-zoom, so it is added there only. Other
 * browsers would honour it and block pinch-zoom (WCAG 1.4.4), so `index.html` stays without it.
 */
export function isAppleTouchDevice(nav: { userAgent: string; maxTouchPoints: number }): boolean {
  if (/iPhone|iPad|iPod/.test(nav.userAgent)) return true;
  // iPadOS Safari says it is a Mac; a real Mac has no touch screen.
  return /Macintosh/.test(nav.userAgent) && nav.maxTouchPoints > 1;
}

export function withoutFocusZoom(content: string): string {
  return /maximum-scale/.test(content) ? content : `${content}, maximum-scale=1`;
}

/** Applies {@link withoutFocusZoom} to the page's viewport on iPhone and iPad. */
export function preventFocusZoomOnApple(doc: Document, nav: Navigator): void {
  if (!isAppleTouchDevice(nav)) return;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (meta) meta.content = withoutFocusZoom(meta.content);
}
